import { HTTP } from '../../utils'

export const populateClub = (uuid) => {
  return HTTP().get('/club/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveClub = (clubObj) => {
  return HTTP().put('/club/' + clubObj.uuid, clubObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const saveNewClub = (clubObj) => {
  console.log('in save new club...')
  console.log('clubObj: ' + clubObj)
  return HTTP().put('/club?parentSpaceId=' + clubObj.owningLibraryId, clubObj)
    .then(response => {
      console.log(response)
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const doCsvUploadForClub = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/club/csvupload?createdByUuid=' + createdByUuid + '&folderId=' + folderId + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/club/api.js